import { Component } from '@angular/core';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';
import { RoleService } from '../../services/role.service';
import { ApplicationRole } from '../../models/access-management/application-role.model';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

@Component({
  selector: 'spv2-application-roles-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class ApplicationRolesDropdownComponent extends DropdownBaseComponent<void, ApplicationRole> {

  uniqueName = "applicationRoles"

  textField = "name";
  valueField = "id";

  enableCache = true;

  dataFunction = () => this.roleService.getApplicationRoles();

  constructor(private roleService: RoleService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }

}
